<!-- グローバルナビ -->
<template>
  <nav v-if="isDataFetched">
    <ul>
      <li
        v-for="item in displayedItems"
        :key="item.categoryId + item.categoryName + item.displayOrder"
      >
        <template v-if="item.categoryId === '999'">
          <a
            :href="item.linkUrl"
            :target="item.isSaparateTab ? '_blank' : '_self'"
            :class="{ hasChildren: item.children && item.children.length > 0 }"
          >
            {{ item.categoryName }}
            <!-- 通知バッジ -->
            <!-- 親の場合、子の合計値（または子がなければ親の値）を計算 -->
            <span
              v-if="getNotificationCount(item) > 0"
              :class="[
                'notification-badge',
                { 'small-font': getNotificationCount(item) > 99 },
              ]"
            >
              {{
                getNotificationCount(item) > 99
                  ? "99+"
                  : getNotificationCount(item)
              }}
            </span>
            <span
              v-if="item.children && item.children.length > 0"
              class="blt1"
            ></span>
          </a>
        </template>
        <template v-else>
          <router-link
            :to="item.linkUrl"
            :target="item.isSaparateTab ? '_blank' : '_self'"
            :class="{ hasChildren: item.children && item.children.length > 0 }"
          >
            {{ item.categoryName }}
            <!-- 通知バッジ -->
            <span
              v-if="getNotificationCount(item) > 0"
              :class="[
                'notification-badge',
                { 'small-font': getNotificationCount(item) > 99 },
              ]"
            >
              {{
                getNotificationCount(item) > 99
                  ? "99+"
                  : getNotificationCount(item)
              }}
            </span>
            <span
              v-if="item.children && item.children.length > 0"
              class="blt1"
            ></span>
          </router-link>
        </template>

        <div v-if="item.children && item.children.length > 0">
          <ul>
            <li
              v-for="child in item.children"
              :key="child.categoryId + child.categoryName + child.displayOrder"
            >
              <template v-if="child.categoryId === '999'">
                <a
                  :href="child.linkUrl"
                  :target="child.isSaparateTab ? '_blank' : '_self'"
                  >{{ child.categoryName }}
                  <!-- 通知バッジ -->
                  <span
                    v-if="getCategoryNoftCnt(child.categoryId) > 0"
                    :class="[
                      'notification-badge',
                      {
                        'small-font': getCategoryNoftCnt(child.categoryId) > 99,
                      },
                    ]"
                  >
                    {{
                      getCategoryNoftCnt(child.categoryId) > 99
                        ? "99+"
                        : getCategoryNoftCnt(child.categoryId)
                    }}
                  </span>
                </a>
              </template>
              <template v-else>
                <router-link
                  :to="child.linkUrl"
                  :target="child.isSaparateTab ? '_blank' : '_self'"
                  >{{ child.categoryName }}
                  <!-- 通知バッジ -->
                  <span
                    v-if="getCategoryNoftCnt(child.categoryId) > 0"
                    :class="[
                      'notification-badge',
                      {
                        'small-font': getCategoryNoftCnt(child.categoryId) > 99,
                      },
                    ]"
                  >
                    {{
                      getCategoryNoftCnt(child.categoryId) > 99
                        ? "99+"
                        : getCategoryNoftCnt(child.categoryId)
                    }}
                  </span>
                </router-link>
              </template>
            </li>
          </ul>
        </div>
      </li>
      <li v-if="otherItems.length > 0">
        <a href="#" class="hasChildren">
          その他
          <span class="blt1"></span>
        </a>
        <div>
          <ul>
            <li
              v-for="other in otherItems"
              :key="other.categoryId + other.categoryName + other.displayOrder"
            >
              <template v-if="other.categoryId === '999'">
                <a
                  :href="other.linkUrl"
                  :target="other.isSaparateTab ? '_blank' : '_self'"
                  >{{ other.categoryName }}
                  <span
                    v-if="getNotificationCount(other) > 0"
                    :class="[
                      'notification-badge',
                      { 'small-font': getNotificationCount(other) > 99 },
                    ]"
                  >
                    {{
                      getNotificationCount(other) > 99
                        ? "99+"
                        : getNotificationCount(other)
                    }}
                  </span>
                </a>
              </template>
              <template v-else>
                <router-link
                  :to="other.linkUrl"
                  :target="other.isSaparateTab ? '_blank' : '_self'"
                  >{{ other.categoryName }}
                  <span
                    v-if="getNotificationCount(other) > 0"
                    :class="[
                      'notification-badge',
                      { 'small-font': getNotificationCount(other) > 99 },
                    ]"
                  >
                    {{
                      getNotificationCount(other) > 99
                        ? "99+"
                        : getNotificationCount(other)
                    }}
                  </span>
                </router-link>
              </template>
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <div v-if="errorMessage" class="error">{{ errorMessage }}</div>
  </nav>
</template>

<script lang="ts">
import { AppConstants } from "@/constants/AppConstants";
import { defineComponent, computed, ref, onMounted } from "vue";
import { useGlobalNaviStore } from "../../store/grovalNaviStore";
import apiAuthClient from "@/util/apiClientAuth";
import { outputDebugLogs } from "@/Common";
interface NotificationInfo {
  categoryId: string; // カテゴリID
  notificationNum: number; // 通知件数
}

export default defineComponent({
  name: "GlobalNavComponent",
  setup() {
    const { items, errorMessage } = useGlobalNaviStore();
    const agCode = ref(""); // AGコード
    const userId = ref(""); // ユーザーID
    const pseudoAgCode = ref(""); // 疑似ログインAGコード
    const pseudoUserId = ref(""); // 疑似ログインユーザーID
    const serchAgCode = ref(""); // 検索用AGコード
    const serchUserId = ref(""); // 検索用ユーザーID
    const maxItems = 5;
    // 通知件数を管理するリアクティブなオブジェクト
    const notificationList = ref<NotificationInfo[]>([]);
    const isDataFetched = ref(false); // データが取得済みかどうかを追跡

    // 通知件数を取得する関数
    const getNotificationCounts = async () => {
      try {
        const response = await apiAuthClient.post(
          "/api/GlobalNavi/getNotificationBadges",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
          }
        );

        // レスポンスから通知情報リストを取得
        notificationList.value = response.data.notificationList;

        outputDebugLogs("response.data: " + response.data);
        outputDebugLogs("response.data: " + response.data.notificationList);
      } catch (error) {
        outputDebugLogs("通知件数の取得に失敗しました: " + error);
      }
    };

    // 初回表示時（初回マウント時）に取得
    onMounted(() => {
      // ローカルストレージからユーザー情報を取得して内部変数に展開
      const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
      if (userInfo) {
        const parsedUserInfo = JSON.parse(userInfo);
        agCode.value = parsedUserInfo.agCode;
        userId.value = parsedUserInfo.userId;
        pseudoAgCode.value = parsedUserInfo.pseudoAgCode;
        pseudoUserId.value = parsedUserInfo.pseudoUserId;

        if (pseudoUserId.value == "") {
          // 疑似ログインIDが空の場合は、疑似ログインしていないとみなす
          serchUserId.value = userId.value;
          serchAgCode.value = agCode.value;
        } else {
          serchUserId.value = pseudoUserId.value;
          serchAgCode.value = pseudoAgCode.value;
        }
      }

      getNotificationCounts();

      isDataFetched.value = true;
    });

    const rootItems = computed(() => {
      return Array.isArray(items.value)
        ? items.value.filter((item) => item.parentId === "")
        : [];
    });

    const displayedItems = computed(() => {
      return rootItems.value.slice(0, maxItems).map((item) => {
        const children = items.value.filter(
          (child) => child.parentId === item.categoryId
        );
        return { ...item, children };
      });
    });

    const otherItems = computed(() => {
      if (rootItems.value.length <= maxItems) return [];
      return rootItems.value.slice(maxItems).map((item) => {
        const children = items.value.filter(
          (child) => child.parentId === item.categoryId
        );
        return { ...item, children };
      });
    });

    const getCategoryNoftCnt = (categoryId: string): number => {
      const found = notificationList.value.find(
        (info) => info.categoryId === categoryId
      );
      return found ? found.notificationNum : 0;
    };

    /**
     * 指定のカテゴリーの通知件数を返す
     *  ・子カテゴリーが存在する場合は、子全体の合計を返す
     *  ・子カテゴリーがない場合は、該当カテゴリー自身の通知件数を返す
     */
    const getNotificationCount = (item: any): number => {
      if (item.children && item.children.length > 0) {
        return item.children.reduce((acc: number, child: any) => {
          return acc + (getCategoryNoftCnt(child.categoryId) || 0);
        }, 0);
      }
      return getCategoryNoftCnt(item.categoryId) || 0;
    };

    return {
      items,
      displayedItems,
      otherItems,
      errorMessage,
      getNotificationCount,
      getCategoryNoftCnt,
      isDataFetched,
    };
  },
});
</script>
<style>
.hasChildren {
  position: relative;
}
</style>
<style scoped>
.notification-badge {
  display: inline-block;
  background-color: red;
  color: white;
  border-radius: 12px;
  padding: 2px 6px;
  font-size: 12px;
  line-height: 1;
  margin-left: 5px;
}

/* 99+ の場合に適用する追加スタイル */
.notification-badge.small-font {
  font-size: 10px; /* 通常より小さく設定 */
}
</style>
